/**
 * @format
 * @module lib/recommended/api
 */
import { validStatus, handleJSON } from "utils/fetch";

const endpoint = "https://recoapi-prd.theglobeandmail.ca/v1/";

const apis = {
  tgam: {
    endpoint,
    requestFactory: (operation, params) => {
      return fetch(`${apis.tgam.endpoint}${operation}`, {
        type: "json",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params)
      })
        .then(validStatus)
        .then(handleJSON);
    },
    discard: params => {
      return apis.tgam.requestFactory("rating", params);
    },
    recommendations: params => {
      return apis.tgam.requestFactory("recommendations", params);
    }
  }
};

export default function api(service, method, params) {
  return apis[service][method](params);
}
